import React from "react"
import PropTypes from "prop-types"

import ServiceCard from "shared/components/service_card.js"
import { serviceShape } from "app/lib/shared_prop_types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

const SearchServiceCard = ({ service, position, term, path, location }) => {
  const handleOnClick = () => {
    logIFTTTNextAction("click", {
      location_type: location,
      object_id: service.module_name,
      object_type: "service",
      position,
      query: term,
    })
  }

  return (
    <li className="service-card-list-item">
      <ServiceCard service={service} onClick={handleOnClick} path={path} />
    </li>
  )
}

SearchServiceCard.propTypes = {
  location: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  service: serviceShape.isRequired,
  term: PropTypes.string,
}

SearchServiceCard.defaultProps = {
  service: {},
}

export default SearchServiceCard
